import React, { useEffect, useState } from 'react';
import styles from './Modal2.module.css';

const Modal2 = ({ isOpen, onClose, children, isLoading = false }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);
 
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = 'hidden';
    } else if (shouldRender) {
      setIsClosing(true);

      const timer = setTimeout(() => {
        setShouldRender(false);
        setIsClosing(false);
        document.body.style.overflow = 'auto';
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === 'Escape' && !isLoading) {
        onClose();
      }
    };
    document.addEventListener('keydown', escHandler);
    return () => document.removeEventListener('keydown', escHandler);
  }, [onClose, isLoading]);

  const handleClose = () => {
    if (isLoading) return; // Prevent close if loading
    
    setIsClosing(true);
    setTimeout(() => {
      setShouldRender(false);
      document.body.style.overflow = 'auto';
      setIsClosing(false);
      onClose();
    }, 300);
  };

  const handleBackdropClick = () => {
    if (!isLoading) {
      handleClose();
    }
  };

  if (!shouldRender) return null;

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div
        className={`${styles.modalContainer} ${isClosing ? styles.slideDown : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modal}>
          <button 
            className={styles.closeBtn} 
            onClick={handleClose}
            disabled={isLoading}
            style={{ 
              opacity: isLoading ? 0.5 : 1, 
              cursor: isLoading ? 'not-allowed' : 'pointer' 
            }}
          >
            <img src='images/cross-icon.png' alt='cross-icon' />
          </button>

          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal2;